module.exports = __webpack_public_path__ + "img/1587766366.eeb78586.jpg";